module.exports = __webpack_public_path__ + "static/media/ASingleShard.e53a6ff8.jpg";